module.exports = __webpack_public_path__ + "img/img-shop-food-5.fb8b92b4.png";